import Button from '@odc-shared/components/Button';
import Dropdown, { IDropdown } from '@odc-shared/components/Dropdown';
import { Tooltip } from '@tencent/one-design-next';
import classNames from 'classnames';
import React, { useState } from 'react';

import './index.scss';

export interface IDropMenuItem {
  value: string | number;
  label: string | React.ReactNode;
  disabled?: boolean;
  disabledTooltip?: string;
}

export interface IDropMenu<T> extends IDropdown {
  children: React.ReactNode;
  data: T[];
  onClick?: (value: string | number, data: T) => void;
}

const DropMenu = <T extends IDropMenuItem>(props: IDropMenu<T>) => {
  const [tooltipVisible, setTooltipVisible] = useState<Record<string | number, boolean>>({});
  const { children, data = [], className = '', dropdownPortalClassName = '', onClick, ...rest } = props;
  return (
    <Dropdown
      align="center"
      offsetData={{ top: -8 }}
      dropdownPortalClassName={classNames('odc-dropdown-menu-portal', dropdownPortalClassName)}
      className={classNames('odc-dropdown-menu', className)}
      {...rest}
    >
      <Dropdown.Trigger>
        {children}
      </Dropdown.Trigger>
      <Dropdown.Content>
        {data.map((item) => (
          <Tooltip
            key={item.value}
            popup={item.disabled ? item.disabledTooltip : ''}
            arrowed={false}
            visible={!!item.disabled && !!item.disabledTooltip && tooltipVisible[item.value]}
            onVisibleChange={(visible) => {
              setTooltipVisible((prev) => ({ ...prev, [item.value]: visible }));
            }}
            placement="bottom"
          >
            <Button
              size="sm"
              disabled={item.disabled}
              onClick={() => {
                if (item.disabled) return;
                onClick?.(item.value, item);
              }}
            >
              {item.label}
            </Button>
          </Tooltip>
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
};

export default DropMenu;